<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="关键字">
            <a-input v-model="searchP.keyword" placeholder="关键字(标题模糊)" allow-clear ></a-input>
        </a-form-item>

        <a-form-item label="消息ID">
            <a-input v-model="searchP.messageid" placeholder="消息ID" allow-clear ></a-input>
        </a-form-item>

        <a-form-item label="业务类型">
            <messageServiceSelecter :showAll="true" :channelcode="searchP.channelcode" @onmessageserviceCodeChange="handleMessageServiceChange"></messageServiceSelecter>
        </a-form-item>

        <a-form-item label="通道类型">
            <passwayTypeSelecter :showAll="true" :isdisable="false" @passwayTypeChange="handlepasswayTypeChange"></passwayTypeSelecter>
        </a-form-item>

        <a-form-item label="发送时间">
            <a-range-picker ref="cTimeRange"
            :show-time="{
                        hideDisabledOptions: true,
                        format:'HH:mm'
                    }" :format="dateFormat"
            v-model="timeRange"
            @change="onChange" />
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>

        </a-form-item>
    </a-form>
</template>

<script>
import moment from 'moment';
import messageServiceSelecter from '../../components/messageServiceSelecter'
import passwayTypeSelecter from '../../components/passwaytypeSelecter'
export default {
    components:{
        messageServiceSelecter,
        passwayTypeSelecter
    },
    data(){
        return {
            form: this.$form.createForm(this),
            timeRange:undefined,
            dateFormat:"YYYY-MM-DD HH:mm",
            searchP:{
                messageid:'',
                keyword:'',
                messageservicecode:'',
                channelcode:'',
                passwaytype:'',
                starttime:'',
                endtime:'',
            }
        }
    },
    methods:{
        onChange(v,t){
            this.searchP.starttime = t[0];
            this.searchP.endtime = t[1]
            console.log(this.timeRange)
        },
        handleMessageServiceChange(msg){
            this.searchP.messageservicecode = msg.messageservicecode
        },
        handlepasswayTypeChange(msg){
            this.searchP.passwaytype = msg.passwaytype
        },
        handleSubmit(sp){
            this.searchP.channelcode = sp.channelcode
            this.$emit("handleSearch",this.searchP);
        },

    },
    mounted(){
        let result = this.G.getRecentDate(12);
        let sTime = result.start_time;
        let eTime = result.end_time;
        this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)]
        this.searchP.starttime = sTime;
        this.searchP.endtime = eTime
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

